import React from 'react'
import { formatDate } from '../apps/professional-app/fa/common/aifeatures/utils'

type FormattedDateProps = {
  date: string
  invalidDateText?: string
}

const FormattedDate: React.FC<FormattedDateProps> = ({ date, invalidDateText = 'Invalid Date' }: FormattedDateProps) => {
  const formattedDate = formatDate(date)
  if (formattedDate === 'Invalid Date') {
    return <span>{invalidDateText}</span>
  }
  return (
    <span data-tip={date} data-for='date-tooltip'>
      {formattedDate}
    </span>
  )
}

export default FormattedDate
